import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "formulario-modelo" }
const _hoisted_2 = { class: "info-bar" }
const _hoisted_3 = { class: "badge" }
const _hoisted_4 = { class: "export-bar" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "filtros-bar" }
const _hoisted_8 = { class: "filtro-grupo" }
const _hoisted_9 = { class: "filtro-grupo" }
const _hoisted_10 = { class: "filtro-grupo" }
const _hoisted_11 = { class: "filtro-grupo" }
const _hoisted_12 = { class: "filtro-grupo" }
const _hoisted_13 = {
  key: 0,
  class: "info"
}
const _hoisted_14 = {
  key: 1,
  class: "contenedor-tabla"
}
const _hoisted_15 = {
  key: 0,
  class: "lista-tabla"
}
const _hoisted_16 = { class: "badge-accion" }
const _hoisted_17 = { class: "detalle-cell" }
const _hoisted_18 = {
  key: 1,
  class: "mensaje-vacio"
}
const _hoisted_19 = { class: "botones" }

import { ref, computed, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { useGestionAuditoria } from '@/store/GestionAuditoria'
import MensajeToast from '@/components/MensajeToast.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'AuditoriaView',
  setup(__props) {

/**
 * Auditoría de las calificaciones de una versión.
 *
 * Solo lectura y exportación: la bitácora no se edita ni se borra, porque un
 * registro modificable no sirve como evidencia.
 *
 * ── Enrutado ─────────────────────────────────────────────────────
 *   `/version/:id_version/auditoria` (AuditoriaEvaluaciones) — permiso `calificacion.ver`
 *
 * Vista enrutada. Obtiene sus datos a través de stores Pinia: no llama a `http`
 * ni a los servicios directamente.
 */

const route = useRoute()
const idVersion = Number(route.params.id_version)
const auditoriaStore = useGestionAuditoria()
const toastRef = ref<InstanceType<typeof MensajeToast> | null>(null)

const loading = ref(false)
const exportando = ref(false)

const filtroUsuario = ref<number | null>(null)
const filtroIndicador = ref<number | null>(null)
const filtroAccion = ref('')
const filtroFechaDesde = ref('')
const filtroFechaHasta = ref('')

const registrosFiltrados = computed(() => {
  return auditoriaStore.registros.filter(r => {
    if (filtroUsuario.value && r.id_usuario !== filtroUsuario.value) return false
    if (filtroIndicador.value && r.id_indicador !== filtroIndicador.value) return false
    if (filtroAccion.value && !(r.accion ?? '').toLowerCase().includes(filtroAccion.value.toLowerCase())) return false
    if (filtroFechaDesde.value) {
      const fecha = r.fecha ?? r.created_at
      if (!fecha || fecha < filtroFechaDesde.value) return false
    }
    if (filtroFechaHasta.value) {
      const fecha = r.fecha ?? r.created_at
      if (!fecha || fecha.substring(0, 10) > filtroFechaHasta.value) return false
    }
    return true
  })
})

function limpiarFiltros() {
  filtroUsuario.value = null
  filtroIndicador.value = null
  filtroAccion.value = ''
  filtroFechaDesde.value = ''
  filtroFechaHasta.value = ''
}

function showToast(msg: string, tipo: 'exito' | 'error' = 'exito') {
  toastRef.value?.showToast(msg, tipo)
}

function formatDetalle(detalle: unknown): string {
  if (!detalle) return '-'
  if (typeof detalle === 'string') return detalle.length > 100 ? detalle.substring(0, 100) + '...' : detalle
  return JSON.stringify(detalle).substring(0, 100) + '...'
}

function formatFecha(fecha?: string | null): string {
  if (!fecha) return '-'
  const d = new Date(fecha)
  return isNaN(d.getTime()) ? fecha : d.toLocaleDateString('es-CO', {
    year: 'numeric', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit'
  })
}

async function exportar(formato: 'json' | 'csv') {
  exportando.value = true
  try {
    await auditoriaStore.exportar(idVersion, formato)
    showToast(`Exportación ${formato.toUpperCase()} descargada`)
  } catch {
    showToast('Error al exportar', 'error')
  } finally {
    exportando.value = false
  }
}

onMounted(async () => {
  if (!Number.isFinite(idVersion) || idVersion <= 0) return
  loading.value = true
  try {
    await auditoriaStore.cargarPorVersion(idVersion)
  } finally {
    loading.value = false
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[14] || (_cache[14] = _createElementVNode("h1", null, "Auditoría de Evaluaciones", -1)),
    _cache[15] || (_cache[15] = _createElementVNode("div", { class: "divider" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, "Versión #" + _toDisplayString(_unref(idVersion)), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("button", {
        class: "btn guardar",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (exportar('json'))),
        disabled: exportando.value
      }, " Exportar JSON ", 8, _hoisted_5),
      _createElementVNode("button", {
        class: "btn guardar",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (exportar('csv'))),
        disabled: exportando.value
      }, " Exportar CSV ", 8, _hoisted_6)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _cache[8] || (_cache[8] = _createElementVNode("label", null, "Usuario:", -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filtroUsuario).value = $event)),
          type: "number",
          min: "1",
          class: "form-control form-sm",
          placeholder: "ID"
        }, null, 512), [
          [
            _vModelText,
            filtroUsuario.value,
            void 0,
            { number: true }
          ]
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _cache[9] || (_cache[9] = _createElementVNode("label", null, "Indicador:", -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filtroIndicador).value = $event)),
          type: "number",
          min: "1",
          class: "form-control form-sm",
          placeholder: "ID"
        }, null, 512), [
          [
            _vModelText,
            filtroIndicador.value,
            void 0,
            { number: true }
          ]
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _cache[10] || (_cache[10] = _createElementVNode("label", null, "Acción:", -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filtroAccion).value = $event)),
          class: "form-control form-sm",
          placeholder: "Ej: creacion"
        }, null, 512), [
          [_vModelText, filtroAccion.value]
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _cache[11] || (_cache[11] = _createElementVNode("label", null, "Desde:", -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((filtroFechaDesde).value = $event)),
          type: "date",
          class: "form-control form-sm"
        }, null, 512), [
          [_vModelText, filtroFechaDesde.value]
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _cache[12] || (_cache[12] = _createElementVNode("label", null, "Hasta:", -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((filtroFechaHasta).value = $event)),
          type: "date",
          class: "form-control form-sm"
        }, null, 512), [
          [_vModelText, filtroFechaHasta.value]
        ])
      ]),
      _createElementVNode("button", {
        class: "btn btn-sm guardar",
        onClick: limpiarFiltros
      }, "Limpiar")
    ]),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, "Cargando registros de auditoría..."))
      : (_openBlock(), _createElementBlock("div", _hoisted_14, [
          (registrosFiltrados.value.length)
            ? (_openBlock(), _createElementBlock("table", _hoisted_15, [
                _cache[13] || (_cache[13] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, "ID"),
                    _createElementVNode("th", null, "Evaluación"),
                    _createElementVNode("th", null, "Indicador"),
                    _createElementVNode("th", null, "Usuario"),
                    _createElementVNode("th", null, "Acción"),
                    _createElementVNode("th", null, "Detalle"),
                    _createElementVNode("th", null, "Fecha")
                  ])
                ], -1)),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(registrosFiltrados.value, (r) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: r.id
                    }, [
                      _createElementVNode("td", null, _toDisplayString(r.id), 1),
                      _createElementVNode("td", null, _toDisplayString(r.id_evaluacion ?? '-'), 1),
                      _createElementVNode("td", null, _toDisplayString(r.id_indicador ?? '-'), 1),
                      _createElementVNode("td", null, _toDisplayString(r.id_usuario ?? '-'), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("span", _hoisted_16, _toDisplayString(r.accion ?? '-'), 1)
                      ]),
                      _createElementVNode("td", _hoisted_17, _toDisplayString(formatDetalle(r.detalle)), 1),
                      _createElementVNode("td", null, _toDisplayString(formatFecha(r.fecha ?? r.created_at)), 1)
                    ]))
                  }), 128))
                ])
              ]))
            : (_openBlock(), _createElementBlock("p", _hoisted_18, "No hay registros de auditoría que coincidan con los filtros."))
        ])),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("button", {
        class: "btn salir",
        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$router.back()))
      }, "Volver")
    ]),
    _createVNode(MensajeToast, {
      ref_key: "toastRef",
      ref: toastRef
    }, null, 512)
  ]))
}
}

})